import Vue from 'vue'
import VueImageCompare from 'vue-image-compare'

Vue.use(VueImageCompare)
